module.exports = __webpack_public_path__ + "img/imgs-item-1.788cb3eb.png";